<template>
    <v-dialog max-width="600px" v-model="dialog">
        <v-btn slot="activator" flat class="success">Add customer</v-btn>
        <v-card>
            <v-card-title>
                <h2>Add a new customer</h2>
            </v-card-title>
            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-text-field label="first" v-model="first" prepend-icon="folder" :rules="inputRules"></v-text-field>
                    <v-text-field label="last" v-model="last" prepend-icon="folder" :rules="inputRules"></v-text-field>
                    <v-text-field label="email" v-model="email" prepend-icon="folder" :rules="inputRules"></v-text-field>
                    
                    <v-textarea label="description" v-model="description" prepend-icon="edit" :rules="inputRules"></v-textarea>
                    
                    <!-- <v-menu>
                        <v-text-field :value="formattedDate" slot="activator" label="Due date" prepend-icon="date_range" :rules="inputRules"></v-text-field>
                        <v-date-picker v-model="due"></v-date-picker>
                    </v-menu> -->
                    <v-spacer></v-spacer>
                    <v-btn @click="submit" :loading="loading" class="mx-0 mt-3">Add customer</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
// TODO:
// field validation
// fix email field


import db from '@/fb'
import firebase from 'firebase'
//require('firebase/auth')

export default {
    data() {
        return {
            first: '',
            last: '',
            email: '',
            description: '',
            // due: null,
            inputRules: [
                v =>  v && v.length >= 3 || 'Minimum length is 3 characters'
            ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                // TODO: Error check to make sure customer doesn't already exist
                // TODO: clear form fields after submit

                this.loading=true
                
                console.log("start the stripe call")
                let newCustomer = firebase.functions().httpsCallable('createCustomer')
                newCustomer({ description: this.description, email: this.email }).then(result=>{
                    db.collection('customers').add({
                        first: this.first,
                        last: this.last,
                        email: this.email,
                        description: this.description,
                        stripe_id: result.data.id
                    })
                })
                .then(()=>{
                    console.log("Successfully added to DB")
                    //this.$router.push({name: 'Customers'})
                    this.loading=false
                    this.dialog=false
                    this.$emit('customerAdded')
                })
                . catch(err => {
                    //this.feedback = err
                    console.log(err)
                })
            } else {
                //this.feedback = "you must enter all fields"
                console.log("you must enter all fields")
            }

            //     const customer = {
            //         description: this.description,
            //         email: this.email,
            //         first: this.first,
            //         last: this.last,
            //         stripe_id: 'nada',
            //         // due: format(this.due, "do MMM YYYY"),
            //     }

            //     db.collection('customers').add(customer).then(()=>{
            //         console.log("added to db")
            //         this.loading=false
            //         this.dialog=false
            //         this.$emit('customerAdded')
            //     })
            // }
        }
        }
        
    }
</script>
